import { TabType } from 'components/Tabs';

import { FormItem } from 'sections/EditForm';
import { Data } from '../components/Data';

export const addNewSeasonFormData: FormItem[] = [
  {
    name: 'season',
    value: '',
    label: 'Name',
    type: 'input',
    advancedValidation: {

    },
  },
  {
    name: 'descIt',
    value: '',
    label: 'Italian description',
    type: 'input',
  },
  {
    name: 'descEng',
    value: '',
    label: 'English description',
    type: 'input',
  },
];

export const manageCategoriesTabs: TabType[] = [
  {
    id: 1,
    title: 'Data',
    content: <Data />,
  },
];
